import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useMaintenanceMode = () => {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkMaintenanceMode = async () => {
      try {
        const { data, error } = await supabase
          .from('site_settings')
          .select('value')
          .eq('key', 'maintenance_mode')
          .maybeSingle();

        if (error) {
          console.error('Error checking maintenance mode:', error);
          setIsMaintenanceMode(false);
        } else {
          const isEnabled = data?.value === 'true';
          if (import.meta.env.DEV) {
            console.log('Maintenance mode status:', isEnabled, 'Raw value:', data?.value);
          }
          setIsMaintenanceMode(isEnabled);
        }
      } catch (error) {
        console.error('Error checking maintenance mode:', error);
        setIsMaintenanceMode(false);
      } finally {
        setLoading(false);
      }
    };

    checkMaintenanceMode();

    // Subscribe to changes with error handling
    let channel: any = null;
    try {
      if (import.meta.env.DEV) {
        console.log('Attempting to subscribe to maintenance mode changes...');
      }
      channel = supabase
        .channel('maintenance-mode-changes')
        .on(
          'postgres_changes',
          {
            event: '*',
            schema: 'public',
            table: 'site_settings',
            filter: `key=eq.maintenance_mode`,
          },
          (payload) => {
            if (import.meta.env.DEV) {
              console.log('Maintenance mode change detected:', payload);
            }
            if (payload.new && 'value' in payload.new) {
              setIsMaintenanceMode((payload.new as any).value === 'true');
            }
          }
        );

      channel.subscribe((status: string, err?: Error) => {
        if (import.meta.env.DEV) {
          console.log('Maintenance mode subscription status:', status);
        }
        if (err) {
          console.error('Maintenance mode subscription error:', err);
        }
      });
    } catch (err) {
      console.error('Failed to initialize maintenance mode subscription:', err);
    }

    return () => {
      if (channel) {
        if (import.meta.env.DEV) {
          console.log('Removing maintenance mode channel');
        }
        supabase.removeChannel(channel);
      }
    };
  }, []);

  return { isMaintenanceMode, loading };
};
